import IconInfo from "app/components/Icon/components/IconInfo/IconInfo";
import { SessionHelper } from "app/helpers/sessionHelper";
import React from "react";
import { FormattedMessage } from "react-intl";
import ReactTooltip from "react-tooltip";

const StatementExchangeBetsStatus: React.FC<{
  betStatus: string;
  translatedbetStatus: string;
  cancellationNote: string;
  betId: number;
  finalScores: string;
}> = ({
  betStatus,
  cancellationNote,
  betId,
  finalScores,
  translatedbetStatus,
}) => {
  const isAsianRouteAndSessionView = SessionHelper.isAsianRouteAndSessionView()
    ? "asian"
    : "euro";
  const red =
    betStatus.toLowerCase() === "cancelled" ||
    betStatus.toLowerCase() === "void" ||
    betStatus.toLowerCase() === "lose"
      ? "statement-exchange-cell--red-text test"
      : "";

  return (
    <>
      <div
        className={`statement-exchange-cell  statement-exchange-cell--multiline statement-exchange-cell--center ${red}`}
      >
        <span className={betStatus.toLowerCase()}>{translatedbetStatus}</span>
        {!(
          betStatus.toLowerCase() === "cancelled" ||
          betStatus.toLowerCase() === "void"
        ) ? (
          <span className={betStatus.toLowerCase()}>{finalScores}</span>
        ) : (
          ""
        )}

        <span
          data-tip
          data-for={`cancelReason_${betId}`}
          data-type="light"
          data-effect="solid"
          data-place="top"
          data-background-color="white"
          data-padding="10px"
          data-text-color="var(--error-card-color)"
          data-class={`react-tooltip__custom${
            isAsianRouteAndSessionView ? "__asian" : ""
          }`}
          data-border={true}
          data-border-color="var(--error-color)"
        >
          {(betStatus.toLowerCase() === "cancelled" ||
            betStatus.toLowerCase() === "void") && (
            <>
              <IconInfo />
              <ReactTooltip id={`cancelReason_${betId}`}>
                <FormattedMessage tagName="span" id="reports-reason" />:{" "}
                {cancellationNote ? cancellationNote : "NA"}
              </ReactTooltip>
            </>
          )}
        </span>
      </div>
    </>
  );
};

export default StatementExchangeBetsStatus;
